exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation !== null) {
    const skipLink = document.querySelector("#main-content")
    if (skipLink) {
      skipLink.focus()
    }
  }
}